/* unplugin-vue-components disabled */import script from "./ReminderDefinitionFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ReminderDefinitionFormModal.vue?vue&type=script&setup=true&lang=js"

import "./ReminderDefinitionFormModal.vue?vue&type=style&index=0&id=35f4bf15&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35f4bf15"]])

export default __exports__